import { IFormData } from '../../components/FormHelper/FormHelper.types';
import { IBookedEvent } from '../../types';
import { BaseApiResponse } from '../../types/api.types';
import { IStatement } from '../../types/auth.types';
import { IBookedDining } from '../../types/dining.types';
import { IBookedSport } from '../../types/sports.types';
import instance from './axios';

type BaseResponse = {
  code: string;
  message: string;
  data?: {
    status: number;
  };
};

type MyActivitiesProps = {
  page?: number;
};

type MyBookingsProps = {
  page?: number;
};

const ENDPOINTS = {
  REGISTER: '/auth/register',
  REGISTER_VALIDATION: '/auth/register-verification',
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  FORGOT_USERNAME: '/auth/forgot-username',
  PROFILE: '/accounts/profile',
  RESET_PASSWORD: '/auth/reset-password',
  ACCOUNT_STATEMENT: '/account/my-account',
  MY_BOOKINGS: 'accounts/my-bookings',
  CANCEL_BOOKING: '/account/cancel-booking',
  DELETE_ACCOUNT: '/accounts/delete',
  ECARD_QRCODE: 'account/ecard-qrcode',
  USER_TYPE: 'user-types',
  CHANGE_PASSWORD: '/accounts/change-password',
  MY_ACTIVITIES: '/accounts/my-activities',
};

export type GetMyAccountProps = {
  year: number;
  month: number;
};

export type GetMyBookingProps = {
  type: 'upcoming' | 'past';
};

export type CancelBookingProps = {
  id: number | string;
  type: string;
};

const register = (data: IFormData) => {
  return instance.post<BaseResponse>(ENDPOINTS.REGISTER, data);
};

const registerValidation = (data: IFormData) => {
  return instance.post<BaseResponse>(ENDPOINTS.REGISTER_VALIDATION, data);
};

const login = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.LOGIN, data);
};

const forgotPassword = (data: IFormData) => {
  return instance.post<BaseResponse>(ENDPOINTS.FORGOT_PASSWORD, data);
};

const resetPassword = (data: IFormData) => {
  return instance.post<BaseResponse>(ENDPOINTS.RESET_PASSWORD, data);
};

const deleteAccount = () => {
  return instance.delete<BaseApiResponse>(ENDPOINTS.DELETE_ACCOUNT);
};

const getProfile = () => {
  return instance.get(ENDPOINTS.PROFILE);
};

const updateProfile = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.PROFILE, data, {
    headers: { 'Content-Type': 'application/json' },
  });
};

const forgotUsername = (data: IFormData) => {
  return instance.post<BaseApiResponse>(ENDPOINTS.FORGOT_USERNAME, data);
};

const getMyAccount = ({ year, month }: GetMyAccountProps) => {
  return instance.get<{
    user_login: number;
    user_nicename: number;
    user_email: number;
    display_name: number;
    mbnum: number;
    avatar: number;
    bbalance: number;
    statements: IStatement[];
  }>(ENDPOINTS.ACCOUNT_STATEMENT, {
    params: { year, month },
  });
};

const getMyBooking = (props: MyBookingsProps) => {
  return instance.get<BaseApiResponse>(ENDPOINTS.MY_BOOKINGS, {
    params: props,
  });
};

const cancelBooking = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.CANCEL_BOOKING, data);
};

const getECardQRCode = () => {
  return instance.get(ENDPOINTS.ECARD_QRCODE);
};

const getUserTypes = () => {
  return instance.get(ENDPOINTS.USER_TYPE);
};

const changePassword = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.CHANGE_PASSWORD, data);
};

const getMyActivities = (props: MyActivitiesProps) => {
  return instance.get<BaseApiResponse>(ENDPOINTS.MY_ACTIVITIES, {
    params: props,
  });
};

export const AuthApi = {
  register,
  registerValidation,
  login,
  forgotPassword,
  forgotUsername,
  getProfile,
  updateProfile,
  resetPassword,
  getMyAccount,
  getMyBooking,
  cancelBooking,
  deleteAccount,
  getECardQRCode,
  getUserTypes,
  changePassword,
  getMyActivities,
};
